import {
  ALL_PERMISSIONS,
  normalizePermissionRole,
  rolePermissions,
} from "@/consts/permissions"
import { useAuthStore } from "@/stores/authStore"

export const useIsAllowedPermission = (
  permission: (typeof ALL_PERMISSIONS)[number],
) => {
  const { role } = useAuthStore()

  const permissions = rolePermissions[normalizePermissionRole(role)]

  if (!permissions) {
    return false
  }

  return permissions.includes(permission)
}
